// extracted by mini-css-extract-plugin
export default {"list":"DetailedForecast_list__MCRZX"};